import axios from 'axios';

// Resolve backend URL with same-origin preference.
// On a linked custom domain (e.g. www.aarya24ktcatalogs.com), the platform also routes /api -> backend
// from the same origin. Using a relative URL avoids cross-origin XHRs and keeps cookies (SameSite=Lax)
// flowing reliably without requiring SameSite=None on the backend.
const RAW_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

function resolveBackendUrl() {
  if (typeof window === 'undefined' || !window.location?.hostname) return RAW_BACKEND_URL;
  const host = window.location.hostname;
  // If configured URL points to the SAME host we're on, use relative (avoids redundant cross-origin)
  try {
    if (RAW_BACKEND_URL && new URL(RAW_BACKEND_URL).hostname === host) return '';
  } catch (err) {
    // RAW_BACKEND_URL isn't a valid URL — likely empty/relative; fall through to platform-domain check
    if (process.env.NODE_ENV !== 'production') {
      console.warn('REACT_APP_BACKEND_URL parse failed; falling back to relative API base', err?.message);
    }
  }
  // If we're on a custom (non-emergent, non-localhost) domain, use relative URL
  // — assumes the platform ingress routes /api/* to the backend (true for Emergent deployments).
  const isPlatformDomain = host.endsWith('emergent.host') || host.endsWith('emergentagent.com') || host === 'localhost' || host === '127.0.0.1';
  if (!isPlatformDomain) return '';
  return RAW_BACKEND_URL;
}

const BACKEND_URL = resolveBackendUrl();

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Public API instance — used by /shared/:token and /flipbook/:token pages.
// Does NOT send credentials (no cookies), always same-origin where possible.
// This avoids broken behaviour inside in-app browsers (WhatsApp / Instagram WebView)
// that often refuse credentialed cross-origin requests on mobile.
export const publicApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: false,
  timeout: 25000,
});

export const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `${BACKEND_URL}${url}`;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).filter(Boolean).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};

export default api;
